import React, { useEffect, useState } from "react";
import { SECONDS_HAND_TABS } from "../../constants/seconds-hands-tabs";
import EditingGrid from "./editing-grid";
import TabsContainer from "../tabs/tabs-container";
import PropTypes from "prop-types";

const propTypes = {
  editingOptions: PropTypes.instanceOf(Object).isRequired,
  selectedOption: PropTypes.string,
};

const SecondsHandView = ({ editingOptions, selectedOption }) => {
  const [activeTab, setActiveTab] = useState("standard");
  const [editingOptionsToShow, setEditingOptionsToShow] = useState({});

  useEffect(() => {
    const copiedEditingOptions = { ...editingOptions };

    Object.keys(copiedEditingOptions).forEach((key) => {
      if (copiedEditingOptions[key].type !== activeTab) {
        delete copiedEditingOptions[key];
      }
    });

    setEditingOptionsToShow(copiedEditingOptions)
  }, [activeTab, editingOptions]);

  return (
    <>
      <TabsContainer
        tabs={SECONDS_HAND_TABS}
        activeTab={activeTab}
        onClick={setActiveTab}
      />
      <EditingGrid
        editingOptions={editingOptionsToShow}
        selectedOption={selectedOption}
      />
    </>
  );
};

SecondsHandView.propTypes = propTypes;

export default SecondsHandView;
